import { render, staticRenderFns } from "./NoticeSubmitDocumentsLetter.vue?vue&type=template&id=4b23ae62"
import script from "./NoticeSubmitDocumentsLetter.vue?vue&type=script&lang=js"
export * from "./NoticeSubmitDocumentsLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b23ae62')) {
      api.createRecord('4b23ae62', component.options)
    } else {
      api.reload('4b23ae62', component.options)
    }
    module.hot.accept("./NoticeSubmitDocumentsLetter.vue?vue&type=template&id=4b23ae62", function () {
      api.rerender('4b23ae62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/NoticeSubmitDocumentsLetter.vue"
export default component.exports